<template>
  <div class="about">
    <div class="login-after-box" v-if="isLogin && IsWap">
      <div class="hello-msg-box">
        <span>欢迎您，</span>
        <span>{{name}}</span>
      </div>
      <a @click="doLogout">退出</a>
    </div>
    <div class="about-before-box" v-if="!isLogin">
      <span class="about-tittle" v-show="type === 'KEE'">关于Keysight Engineering Education</span>
      <div class="about-content" v-show="type === 'KEE'">
        是德科技工程基础教育计划，简称KEE：定期邀请是德科技的首席科学家、
        研发Fellow、产品战略规划师等资深技术专家，进行电子测量基础知识线上系列讲座。同时我们创建专业微信群，
        邀请大中华区高级应用工程师同步答疑，群内还会举办不定期的行业讲座、技术交流和干货分享。
      </div>
    </div>
    <div class="about-after-box" v-if="isLogin && type === 'KEE'">
      <span class="about-tittle">KEE 重磅来袭</span>
      <div class="about-content">
        1、资深技术专家团队：研发Fellow、首席科学家、产品战略规划师等；<br/>
        2、内容涵盖无线、射频、数字技术和光通信的基础知识和典型应用。<br/>
        3、本地工程师答疑，配合线上讲座，打造测量圈的云课堂；<br/>
        4、支持往期回看，嘉宾演讲、本地专家交流和资料下载。
      </div>
    </div>
    <div class="about-qrcode-box">
      <div class="qrcode-box">
        <img src="../assets/qrcode.png" alt="" v-show="type === 'KEE'">
        <img src="../assets/kts/qrcodeKts.png" alt="" v-show="type === 'KTS'">
      </div>
      <div class="text-box" v-show="type === 'KEE'">
        扫码添加KEE管理员，验证进群验证信息需注明：<span>单位-姓名-方向</span>，其中方向填写<span>“数字”</span>或者<span>“射频”</span>
      </div>
      <div class="text-box" v-show="type === 'KTS'">
        扫码添加KTS管理员，验证进群验证信息需注明：<span>单位-姓名-方向</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {setCookie, getCookie, removeCookie} from '../utils/public';
  export default {
    name: 'About',
    data() {
      return {
        isLogin: false,
        IsWap: false,
        name: '',
      };
    },
    props: ['screenWidth'],
    computed:{
      loginStatus() {
        return this.$store.state.loginStatus;
      },
      type(){
        return this.$store.state.type;
      },
    },
    mounted(){
      if(this.screenWidth < 750){
        this.IsWap = true;
      }else {
        this.IsWap = false;
      }
    },
    watch: {
      loginStatus: function (val, oVal) {
        let self = this;
        if(val == 1){
          setTimeout(function() {
            self.isLogin = true;
            self.name = self.$store.state.info.firstName + self.$store.state.info.lastName
          }, 1000)
        }else {
          self.isLogin = false
        }

      },
      screenWidth: function (val, oVal) {
        if(val < 750){
          this.IsWap = true;
        }else {
          this.IsWap = false;
        }
      }
    },
    methods: {
      doLogout: function() {
        removeCookie('sess');
        removeCookie('globalUserId');
        removeCookie('smarketMember_'+window.config.schemaId);
        removeCookie('username');
        this.$store.commit('setLoginStatus', 0)
        this.$store.commit('setUserInfo', {})
        // $('.Hui-iconfont-xuanze').removeClass('active');
        // $.Huimodalalert('退出成功',2000);
      },
    }
  };
</script>

<style lang="scss" scoped>
  @media (min-width: 750px) {
    .about {
      padding: 0 32px 30px;
      background-color: #f7f7f7;


      .about-before-box, .about-after-box {
        .about-tittle {
          font-size: 15px;
          font-weight: bold;
          color: $commonRed;
          line-height: 25px;
        }

        .about-content {
          font-size: 13px;
          line-height: 20px;
          color: $color;
        }
      }
      .about-before-box{
        padding-top: 30px;
        border-top: 1px solid #efeeef;
      }

      .about-qrcode-box {
        padding-top: 22px;
        overflow: hidden;

        .qrcode-box {
          float: left;
          margin-right: 17px;
          img{
            width: 92px;
          }
        }

        .text-box {
          padding-top: 17px;
          color: $color;
          span {
            color: $commonRed;
          }
        }
      }
    }
  }
  @media (max-width: 750px) {
    .about {
      margin: 0 auto;
      background-color: #f7f7f7;
      margin: 0 4%;

      .login-after-box {
        margin-top: pxToRem(50);
        padding: pxToRem(68) pxToRem(28) pxToRem(38);
        text-align: center;
        border-top: 2px solid $commonRed;
        background: #f7f7f7;

        .hello-msg-box {
          font-size: pxToRem(34);
          padding-bottom: pxToRem(30);
          font-weight: bold;
          color: $commonRed;
        }

        a {
          font-size: pxToRem(24);
          color: $color;
          cursor: pointer;
          text-decoration: none;
          border-bottom: 1px solid #666666;
        }
      }
      .about-before-box, .about-after-box {
        padding: pxToRem(25) pxToRem(28) pxToRem(0);
        border-top: 1px solid #ededed;
        .about-tittle {
          font-size: pxToRem(24);
          font-weight: bold;
          color: $commonRed;
        }
        .about-content {
          margin-top: pxToRem(10);
          font-size: pxToRem(22);
          line-height: pxToRem(35);
          color: $color;
        }
      }
      .about-before-box{
        border: 0;
        margin-top: pxToRem(50);
        /*padding-top: pxToRem(45);*/
      }

      .about-qrcode-box {
        padding: pxToRem(30) pxToRem(28) pxToRem(35);
        position: relative;

        .qrcode-box {
          img{
            width: pxToRem(130);
          }
        }

        .text-box {
          position: absolute;
          left: pxToRem(175);
          top: pxToRem(36);
          font-size: pxToRem(22);
          padding-top: pxToRem(25);
          color: $color;
          span {
            color: $commonRed;
          }
        }
      }
    }
  }

</style>
